export const API_BASE_URL = 'https://admin.brainershub.in/api';
export const BASE_URL = 'https://admin.brainershub.in';

// export const API_BASE_URL = 'http://localhost/brainershub/api';
// export const BASE_URL = 'http://localhost/brainershub';

export const razorpay_key = 'rzp_live_jJQPZ05uCdNgNS';
export const institute_id = '8';

/** Used by App.jsx to open the Testmeter Android app from testmeter.in, or Play Store if not installed. */
export const TESTMETER_ANDROID_PACKAGE = 'com.testmeter';
export const TESTMETER_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.testmeter';
export const TESTMETER_APP_LINK_HOSTS = ['testmeter.in', 'www.testmeter.in'];
// export const razorpay_key = 'rzp_test_Rf5wtIGvhjhFUi';
